import {STATISTICS_CONTROLLER} from "./route/statisticsController";
import {EMPLOYEE_STATISTIC_COMPONENT} from "./component/employeeStatistics";
import {DRAW_CHART_SERVICE_NAME, STATISTIC_SERVICE_NAME} from "../utils/names/serviceNames";
import {STATISTICS_SERVICE} from "./service/statisticsService";
import StatisticModuleConfiguration from "./StatisticModuleConfiguration";
import {DrawChartService} from "./service/DrawChartService";

StatisticModuleConfiguration
    .createNewModule()
    .controller('statisticsController', STATISTICS_CONTROLLER)
    .component('employeeStatistic', EMPLOYEE_STATISTIC_COMPONENT)
    .service(STATISTIC_SERVICE_NAME, STATISTICS_SERVICE)
    .service(DRAW_CHART_SERVICE_NAME, DrawChartService.instance);
